var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['popit-game', { 'm-finish': _vm.isGameFinished }],style:({ backgroundImage: `url(${_vm.background})` })},_vm._l((_vm.items),function(item){return _c('popit-item',{key:item.id,attrs:{"is-active":item.isActive},on:{"click":() => _vm.onPopitClick(item.id)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }